import axios from 'axios';
import { useEffect, useRef, useState } from 'react';
import { useAlert } from 'react-alert';
import { FcAlarmClock } from "react-icons/fc";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import swal from "sweetalert";
import { BASE_URL } from '../../../insightConfig/insightConfig';
import ResultPreview from '../../ResultPreview/ResultPreview';
import Questionsummary from '../Questionsummary/Questionsummary';
import "./QuestionLayout.css";
// import { toast } from 'react-toastify';
import { createBrowserHistory } from 'history';
import parse from 'html-react-parser';

function QuestionLayoutTestseries() {
  const timerRef = useRef(null);
  const alert = useAlert();
  const navigate = useNavigate();
  const location = useLocation();
  // const { state: { testData } } = useLocation();
  const testData = location?.state?.testData || JSON.parse(localStorage.getItem('testData'));
  const allTestsReportsArray = JSON.parse(localStorage.getItem("TestSeriesReportArray"));
  const currentTestSeriesTitleURL = JSON.parse(localStorage.getItem("CurrentTestSeriesTitleURL"));
  console.log(testData);
  //raaz work 
  const [testQuestions, setTestQuestions] = useState([])
  const [selectedQuestionNumber, setSelectedQuestionNumber] = useState(1)
  const [selectedQuestion, setSelectedQuestion] = useState()
  const [answerOfCurrentQuestion, setAnswerOfCurrentQuestion] = useState('')
  const [attemptedQuestions, setAttemptedQuestions] = useState([])
  const [markForReviewQuestionsArray, setMarkForReviewQuestionsArray] = useState([])
  const [toggleMarkForReview, setToggleMarkForReview] = useState(false)
  const [viewedQuestionsArray, setViewedQuestionsArray] = useState([])
  const [finishTest, setFinishTest] = useState(false)
  const [questionsLoaded, setQuestionsLoaded] = useState(false);


  const hasPushedRef = useRef(false); // persist across renders
  useEffect(() => {
    if (location?.state?.testData) {
      localStorage.setItem('testData', JSON.stringify(location.state.testData));
    }
  }, [location.state]);
  useEffect(() => {
    const { pathname, state } = location;

    const handlePopState = () => {
      if (pathname.includes('testseriesstart')) {
        // Block back by pushing current path & state again
        window.history.pushState(state ?? null, '', pathname);
      }
    };

    if (pathname.includes('testseriesstart')) {
      // Initial push to prevent back navigation
      window.history.pushState(state ?? null, '', pathname);
      window.addEventListener('popstate', handlePopState);
    }

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [location.pathname, location.state]);

  // useEffect(() => {
  //   const handlePopState = (e) => {
  //     if (testData && !finishTest) {
  //       const confirmed = window.confirm('Are you sure you want to leave this page? Your test progress may be lost.');
  //       if (!confirmed) {
  //         window.history.pushState(null, '', window.location.pathname); // Stay on the same page
  //       }
  //     }
  //   };

  //   if (testData && !finishTest) {
  //     window.history.pushState(null, '', window.location.pathname); // Push a dummy state
  //     window.addEventListener('popstate', handlePopState);
  //   }

  //   return () => {
  //     window.removeEventListener('popstate', handlePopState);
  //   };
  // }, [testData && !finishTest]);


  let { packageid } = useParams()
  const storedAuthToken = localStorage.getItem('authtoken');

  //time functionality
  let intialTime = Number(testData?.Duration) * 60
  const [timeRemaining, setTimeRemaining] = useState(intialTime);
  const [timeUp, setTimeUp] = useState(false)
  const minutes = Math.floor(timeRemaining / 60);
  const seconds = (timeRemaining % 60);


  useEffect(() => {
    if (testQuestions.length) {
      setQuestionsLoaded(true);
    }
  }, [testQuestions])

  useEffect(() => {
    if (testQuestions && testQuestions.length > 0) {
      let intialTestResponseObj = new Array(testQuestions?.length).fill(null).map((_, index) => ({
        questionNumber: index + 1,
        selectedOption: '',
        correctOption: testQuestions.find(question => question.QNo == index + 1)?.Answer,
        markForReview: false,
        isQuestionViewed: false,
      }));

      const testSeriesReportArray = JSON.parse(localStorage.getItem("TestSeriesReportArray"));






      if (testSeriesReportArray && testSeriesReportArray?.length > 0) {
        const testToBeContinued = testSeriesReportArray.find((test) => test.packageId === packageid);

        if (testToBeContinued) {
          setTimeRemaining(testToBeContinued?.remainingTime);
          setSelectedQuestionNumber(testToBeContinued.lastQuestion);
          setAttemptedQuestions(testToBeContinued.userResponseObj?.filter((question) => question.selectedOption)?.map((question) => question.questionNumber));
        } else {
          testSeriesReportArray.push({
            isTestFinished: false,
            packageId: packageid,
            reAttempt: testData.reAttempt,
            startTime: new Date(),
            lastQuestion: 1,
            remainingTime: intialTime,
            userResponseObj: intialTestResponseObj
          });

          localStorage.setItem("TestSeriesReportArray", JSON.stringify(testSeriesReportArray));
          setSelectedQuestionNumber(1);
        }
      } else {
        const newTestDetails = [{
          isTestFinished: false,
          packageId: packageid,
          reAttempt: testData.reAttempt,
          startTime: new Date(),
          lastQuestion: 1,
          remainingTime: testData.Duration * 60,
          userResponseObj: intialTestResponseObj,
        }];

        localStorage.setItem("TestSeriesReportArray", JSON.stringify(newTestDetails));
        setSelectedQuestionNumber(1);
        setAttemptedQuestions([]);
      }
    }
  }, [testQuestions])


  useEffect(() => {
    if (finishTest || timeUp) return;

    if (questionsLoaded) {
      timerRef.current = setInterval(() => {
        setTimeRemaining(prevTime => {
          if (prevTime > 0) {
            const allTestsReportsArray = JSON.parse(localStorage.getItem("TestSeriesReportArray")) || [];
            const testIndex = allTestsReportsArray.findIndex(test => test.packageId === packageid);
            if (testIndex !== -1) {
              const copyOfTestDetails = [...allTestsReportsArray];
              copyOfTestDetails[testIndex].remainingTime = prevTime - 1;
              localStorage.setItem("TestSeriesReportArray", JSON.stringify(copyOfTestDetails));
            }
            return prevTime - 1;
          } else {
            if (!timeUp) {
              setTimeUp(true);
              swal("Time's up! Please submit your test.");
            }
            clearInterval(timerRef.current);
            return 0;
          }
        });
      }, 1000);
    }

    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [testData.Duration, packageid, questionsLoaded]);



















  const getCurrentTime = () => {
    const currentTime = new Date();
    let hours = currentTime.getHours();
    let minutes = currentTime.getMinutes();
    let seconds = currentTime.getSeconds();
    hours = (hours < 10 ? '0' : '') + hours;
    minutes = (minutes < 10 ? '0' : '') + minutes;
    seconds = (seconds < 10 ? '0' : '') + seconds;
    return `${hours}:${minutes}:${seconds}`;
  }

  useEffect(() => {
    if (testQuestions?.length === 0) {
      axios.get(`${BASE_URL}/loadTestQuestions/${testData.testSeriesSn}/${packageid}`).then((response) => {
        setTestQuestions(response.data.questions)
      })
    }
    const allTestsReportsArray = JSON.parse(localStorage.getItem("TestSeriesReportArray"));
    const currentTest = allTestsReportsArray?.find((test) => test.packageId == packageid);
    if (currentTest?.isTestFinished == true) {
      setFinishTest(true)
      swal(
        "Test Finished! Please submit your test."
      )
    } else if (currentTest && currentTest?.remainingTime < 1) {
      setTimeUp(true)
      swal(
        "Time's up! Please submit your test."
      )
    }
  }, [])



  useEffect(() => {
    if (selectedQuestionNumber) {
      const allTestsReportsArray = JSON.parse(localStorage.getItem("TestSeriesReportArray"));

      if (allTestsReportsArray) {
        const currentTest = allTestsReportsArray?.find((test) => test.packageId == packageid);

        if (selectedQuestionNumber != testQuestions.length + 1) {
          currentTest.lastQuestion = selectedQuestionNumber;
        }

        const userResponseObjForCurrentTest = currentTest?.userResponseObj
        let questionObj = userResponseObjForCurrentTest?.find((question) => question.questionNumber == selectedQuestionNumber)

        setAnswerOfCurrentQuestion(questionObj?.selectedOption)



        if (questionObj) {
          // questionObj.markForReview = false;
          questionObj.isQuestionViewed = true;
        }
        localStorage.setItem("TestSeriesReportArray", JSON.stringify(allTestsReportsArray));

        setAttemptedQuestions(userResponseObjForCurrentTest?.filter((question) => question.selectedOption)?.map((question) => question.questionNumber));

        setMarkForReviewQuestionsArray(userResponseObjForCurrentTest?.filter((question) => question.markForReview == true)?.map((question) => question.questionNumber))
        setViewedQuestionsArray(userResponseObjForCurrentTest?.filter((question) => question.isQuestionViewed == true)?.map((question) => question.questionNumber))


      }
    }
    let selectedQuestion = testQuestions.find(question => question.QNo == selectedQuestionNumber)
    setSelectedQuestion(selectedQuestion)
  }, [selectedQuestionNumber, testQuestions, answerOfCurrentQuestion, toggleMarkForReview])












  const renderhtml = (paragraphs) => {
    return <p className='renderhtml' dangerouslySetInnerHTML={{ __html: paragraphs }} />;
  };

  const renderhtml1 = (paragraphs) => {
    return <b className='renderhtml1' dangerouslySetInnerHTML={{ __html: paragraphs }} />;
  };

  const selectAnswerHandler = (value) => {
    setAnswerOfCurrentQuestion(value)
    const allTestsReportsArray = JSON.parse(localStorage.getItem("TestSeriesReportArray"));

    const currentTest = allTestsReportsArray?.find((test) => test.packageId == packageid);

    const selectedQuestionObj = currentTest?.userResponseObj?.find(questionObj => questionObj.questionNumber === selectedQuestionNumber);
    selectedQuestionObj.selectedOption = value;
    localStorage.setItem("TestSeriesReportArray", JSON.stringify(allTestsReportsArray));
  }
  const handleClear = () => {
    const allTestsReportsArray = JSON.parse(localStorage.getItem("TestSeriesReportArray"));
    const currentTest = allTestsReportsArray?.find((test) => test.packageId == packageid);

    const selectedQuestionObj = currentTest?.userResponseObj?.find(questionObj => questionObj.questionNumber === selectedQuestionNumber);
    selectedQuestionObj.selectedOption = '';
    localStorage.setItem("TestSeriesReportArray", JSON.stringify(allTestsReportsArray));
    setAnswerOfCurrentQuestion('')
  }
  const handleMarkForReview = () => {
    const allTestsReportsArray = JSON.parse(localStorage.getItem("TestSeriesReportArray"));
    const currentTest = allTestsReportsArray?.find((test) => test.packageId == packageid);
    const selectedQuestionObj = currentTest?.userResponseObj?.find(questionObj => questionObj.questionNumber === selectedQuestionNumber);

    selectedQuestionObj.markForReview = true;
    localStorage.setItem("TestSeriesReportArray", JSON.stringify(allTestsReportsArray));
    setToggleMarkForReview(!toggleMarkForReview)
  }



  const handleFinishTest = () => {
    swal({
      title: "Are you sure?",
      text: "Once finished, you will not be able to return to the test",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((yes) => {
      if (yes) {
        const allTestsReportsArray = JSON.parse(localStorage.getItem("TestSeriesReportArray"));
        const currentTest = allTestsReportsArray?.find((test) => test.packageId == packageid);
        currentTest.isTestFinished = true;
        localStorage.setItem("TestSeriesReportArray", JSON.stringify(allTestsReportsArray));
        setFinishTest(true)
        swal(
          "Test Finished! Please submit your test."
        )
      }
    })
  }
  const deleteReportFromLS = () => {
    const indexOfCurrentTest = allTestsReportsArray?.findIndex((test) => test.packageId == packageid);
    allTestsReportsArray.splice(indexOfCurrentTest, 1)
    localStorage.setItem("TestSeriesReportArray", JSON.stringify(allTestsReportsArray));

  }

  const increaseAttemptCount = async () => {
    try {
      const response = await axios.post(BASE_URL + `/increaseAttemptCount/${testData.testSeriesSn}/${packageid}`)
    } catch (error) {
      console.log(error);
    }

  }


  const finalSubmitTest = async () => {

    try {

      const currentTest = allTestsReportsArray?.find((test) => test.packageId == packageid);
      let correctQuestions = 0;
      let wrongQuestions = 0;
      let correctMarks = 0;
      let wrongMarks = 0;
      let totalQuestions = testQuestions.length;
      let startTime = currentTest.startTime;
      let attemptedQuestions = 0;
      let notVisitedQuestions = 0;

      let userResponseObj = currentTest.userResponseObj;
      notVisitedQuestions = userResponseObj.filter((question) => question.isQuestionViewed !== true)?.length

      userResponseObj.map(obj => {
        if (obj.selectedOption != '') {
          attemptedQuestions++;
          if (obj.correctOption == obj.selectedOption) {
            correctMarks = correctMarks + Number(testData.MarksObtain);
            correctQuestions++;
          } else {
            wrongMarks = wrongMarks + Number(testData.MarkingMinus);
            wrongQuestions++;
          }

        }
      })
      let testReport = { totalQuestions, attemptedQuestions, correctQuestions, wrongQuestions, notVisitedQuestions, correctMarks, wrongMarks, negativeMarking: testData.MarkingMinus, marksPerQuestion: testData.MarksObtain, startTime, answerSheet: userResponseObj }
      if (currentTest?.reAttempt === false) {
        const response = await axios.post(BASE_URL + `/insertTestReport/${testData.testSeriesSn}/${packageid}`, testReport)
        if (response.data.statusCode == 200) {
          deleteReportFromLS();
          swal(response.data.message, {
            icon: "success",
            buttons: {
              confirm: {
                text: "OK",
                value: true,
                visible: true,
                closeModal: true
              }
            }
          }).then(() => {
            navigate('/testseries/finalresult', { state: { testData } })
          })
        }
      } else {
        testReport = {
          totalquestion: testReport.totalQuestions,
          attempted: testReport.attemptedQuestions,
          correct: testReport.correctQuestions,
          wrongquestions: testReport.wrongQuestions,
          testcorrectmarks: testReport.correctMarks,
          testwrongmarks: testReport.wrongMarks,
          answersheet: JSON.stringify(testReport.answerSheet)
        }
        deleteReportFromLS();
        increaseAttemptCount();
        navigate('/TestResultDetailView', { state: { testReport, testData } });
      }
    } catch (error) {
      swal("Oops", "Something went wrong! Please Try Again", { icon: "error" })
      console.log(error)
    }
  }

  const [unsavedChanges, setUnsavedChanges] = useState(true);
  const history = createBrowserHistory();
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (unsavedChanges) {
        const message = "Leave site? Changes you made may not be saved.";
        event.returnValue = message;  // Standard for most browsers
        return message;  // For some older browsers
      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);

    // Block navigation using history
    const unblock = history.block((location, action) => {
      if (unsavedChanges) {
        const message = "Leave site? Changes you made may not be saved.";
        if (window.confirm(message)) {
          unblock();  // Allow the navigation
        } else {
          return false;  // Block the navigation
        }
      }
      return undefined;  // Allow the navigation
    });


    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      unblock();
    };
  }, [unsavedChanges]);





  return (
    <>

      <div className='container-fluid p-3 ' style={{ position: "absolute", top: "0", background: "white", zIndex: "1000" }}>
        {
          testQuestions.length ?
            <div className='row' style={{ height: "150vh" }}>
              <div className='col-lg-8'>
                {!finishTest && !timeUp ? <>
                  <h5 className='bg-warning p-3 d-inline-flex rounded-pill m-2'>
                    <FcAlarmClock className='me-2' /> Time Remaining: <b className='text-danger mx-2'>{String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}</b>
                  </h5>
                  <div className='card questionpreviewpadding'>
                    {selectedQuestion?.QNo ? (
                      <>
                        <span className='text-success fw-bold'>({selectedQuestion.QNo}). </span>
                        {parse(selectedQuestion.Question)}
                      </>
                    ) : null}

                    {/* <span className='text-success fw-bold'>({selectedQuestion?.QNo}). </span>{parse(selectedQuestion?.Question)} */}
                    {/* <p><b>{selectedQuestion?.QNo}. {renderhtml(selectedQuestion?.Question)}</b></p> */}
                    <ul className='answer-list'>
                      <li className={answerOfCurrentQuestion?.includes('A') ? 'selected' : ''} onClick={() => selectAnswerHandler('A')}>
                        <input
                          type="radio"
                          className='me-2 mb-1'
                          style={{ width: "20px", height: "20px" }}
                          name='option1'
                          id='option_1'
                          onClick={() => selectAnswerHandler('A')}
                          checked={answerOfCurrentQuestion?.includes('A')}
                        />
                        <label htmlFor='option_1'>
                          <b>(A) {renderhtml1(selectedQuestion?.OptionA)}</b>
                        </label>
                      </li>
                      <li className={answerOfCurrentQuestion?.includes('B') ? 'selected' : ''} onClick={() => selectAnswerHandler('B')}>
                        <input
                          type="radio"
                          className='me-2 mb-1'
                          style={{ width: "20px", height: "20px" }}
                          name='option2'
                          id='option_2'
                          onClick={() => selectAnswerHandler('B')}
                          checked={answerOfCurrentQuestion?.includes('B')}
                        />
                        <label htmlFor='option_2'>
                          <b>(B) {renderhtml1(selectedQuestion?.OptionB)}</b>
                        </label>
                      </li>
                      <li className={answerOfCurrentQuestion?.includes('C') ? 'selected' : ''} onClick={() => selectAnswerHandler('C')}>
                        <input
                          type="radio"
                          className='me-2 mb-1'
                          style={{ width: "20px", height: "20px" }}
                          name='option3'
                          id='option_3'
                          onClick={() => selectAnswerHandler('C')}
                          checked={answerOfCurrentQuestion?.includes('C')}
                        />
                        <label htmlFor='option_3'>
                          <b>(C) {renderhtml1(selectedQuestion?.OptionC)}</b>
                        </label>
                      </li>
                      <li className={answerOfCurrentQuestion?.includes('D') ? 'selected' : ''} onClick={() => selectAnswerHandler('D')}>
                        <input
                          type="radio"
                          className='me-2 mb-1'
                          style={{ width: "20px", height: "20px" }}
                          name='option4'
                          id='option_4'
                          onClick={() => selectAnswerHandler('D')}
                          checked={answerOfCurrentQuestion?.includes('D')}
                        />
                        <label htmlFor='option_4'>
                          <b>(D) {renderhtml1(selectedQuestion?.OptionD)}</b>
                        </label>
                      </li>

                    </ul>
                  </div>

                  <div className='p-3 d-flex justify-content-betweenn flex-wrap'>
                    <div className='col-lg-8 py-1 pe-3 col-md-8 col-sm-8 d-flex align-items-start flex-nowrap'>
                      {selectedQuestionNumber > 1 && <button type="button" className="btn bg-Question-white btn-md me-3" onClick={() => { setSelectedQuestionNumber(selectedQuestionNumber - 1); window.scrollTo(0, 0); }}>Previous</button>}
                      <button type="button" className="btn bg-Question-white btn-md" onClick={handleClear}>Clear</button>
                      <button type="button" className="btn bg-Question-white btn-md ms-3" style={{ whiteSpace: "nowrap" }} onClick={handleMarkForReview}>Mark for Review</button>

                    </div>
                    <div className='col-lg-4 py-1 col-md-2 col-sm-4 d-flex align-items-start justify-content-end'>
                      {selectedQuestionNumber < testQuestions.length ? <button type="button" className='btn bg-Question-white btn-md' /* className={selectedQuestionNumber <= testQuestions.length ? "btn disable bg-Question-white btn-md" : "btn bg-Question-white btn-md"} */ onClick={() => { setSelectedQuestionNumber(selectedQuestionNumber + 1); window.scrollTo(0, 0); }}>Save & Next</button> :
                        <button type="button" onClick={handleFinishTest} className="btn bg-Question-orange btn-md">FINISH</button>
                      }
                    </div>
                  </div>
                </> :
                  <>
                    <ResultPreview testQuestions={testQuestions} attemptedQuestions={attemptedQuestions} viewedQuestionsArray={viewedQuestionsArray} />
                    <div className='p-2 d-flex justify-content-around'>
                      <button type="button" className="btn bg-Question-white btn-md" onClick={finalSubmitTest}>Final Submit</button>
                    </div>
                  </>

                }

              </div>
              <div className='col-lg-4 p-3 card'>
                <Questionsummary attemptedQuestions={attemptedQuestions} markForReviewQuestionsArray={markForReviewQuestionsArray} testQuestions={testQuestions} viewedQuestionsArray={viewedQuestionsArray} setSelectedQuestionNumber={setSelectedQuestionNumber} selectedQuestionNumber={selectedQuestionNumber} handleFinishTest={handleFinishTest} finishTest={finishTest} totalQuestions={testData.QuestionCount} />
              </div>
            </div > :
            <div className="d-flex flex-column align-items-center justify-content-center vh-100">
              <div className="spinner-border text-primary mb-3" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <h4 className="fw-bold text-secondary">Getting your test ready...</h4>
              <p className="text-muted">Please wait while we load the questions.</p>
            </div>


        }
      </div >
      {/* } */}
      {/* </FullScreen> */}
    </>
  )
}

export default QuestionLayoutTestseries